const deRef = ref => (ref ? ref.current : undefined);

// noinspection JSUnusedGlobalSymbols
export default deRef;
